export default "<button [class.active]=\"active\" [class.blink]=\"blink\" (click)=\"click\"></button>"